/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AiModelWithAssessment } from './AiModelWithAssessment';
import {
  AiModelWithAssessmentFromJSON,
  AiModelWithAssessmentFromJSONTyped,
  AiModelWithAssessmentToJSON,
} from './AiModelWithAssessment';
import type { UseCaseStatusEnum } from './UseCaseStatusEnum';
import {
  UseCaseStatusEnumFromJSON,
  UseCaseStatusEnumFromJSONTyped,
  UseCaseStatusEnumToJSON,
} from './UseCaseStatusEnum';
import type { EuAiActRiskClassEnum } from './EuAiActRiskClassEnum';
import {
  EuAiActRiskClassEnumFromJSON,
  EuAiActRiskClassEnumFromJSONTyped,
  EuAiActRiskClassEnumToJSON,
} from './EuAiActRiskClassEnum';
import type { Department } from './Department';
import { DepartmentFromJSON, DepartmentFromJSONTyped, DepartmentToJSON } from './Department';
import type { CustomQuestionnaireStatus } from './CustomQuestionnaireStatus';
import {
  CustomQuestionnaireStatusFromJSON,
  CustomQuestionnaireStatusFromJSONTyped,
  CustomQuestionnaireStatusToJSON,
} from './CustomQuestionnaireStatus';
import type { MaterialityEnum } from './MaterialityEnum';
import { MaterialityEnumFromJSON, MaterialityEnumFromJSONTyped, MaterialityEnumToJSON } from './MaterialityEnum';
import type { CustomFieldValueRead } from './CustomFieldValueRead';
import {
  CustomFieldValueReadFromJSON,
  CustomFieldValueReadFromJSONTyped,
  CustomFieldValueReadToJSON,
} from './CustomFieldValueRead';

/**
 * Use case shape for the detail endpoint: adds per-model assessment data
 * and custom-questionnaire status, both specific to the detail view.
 * @export
 * @interface UseCaseDetail
 */
export interface UseCaseDetail {
  /**
   *
   * @type {number}
   * @memberof UseCaseDetail
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  businessOwner: string;
  /**
   *
   * @type {Array<Department>}
   * @memberof UseCaseDetail
   */
  readonly department: Array<Department>;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  purpose: string;
  /**
   *
   * @type {EuAiActRiskClassEnum}
   * @memberof UseCaseDetail
   */
  euAiActRiskClass: EuAiActRiskClassEnum;
  /**
   *
   * @type {UseCaseStatusEnum}
   * @memberof UseCaseDetail
   */
  status?: UseCaseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  updateUser?: string;
  /**
   *
   * @type {MaterialityEnum}
   * @memberof UseCaseDetail
   */
  materiality?: MaterialityEnum | null;
  /**
   *
   * @type {Date}
   * @memberof UseCaseDetail
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof UseCaseDetail
   */
  readonly readiness: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UseCaseDetail
   */
  questStatuses: { [key: string]: any };
  /**
   *
   * @type {Array<AiModelWithAssessment>}
   * @memberof UseCaseDetail
   */
  readonly aiModels: Array<AiModelWithAssessment>;
  /**
   *
   * @type {Array<CustomFieldValueRead>}
   * @memberof UseCaseDetail
   */
  readonly customFieldValues: Array<CustomFieldValueRead>;
  /**
   *
   * @type {Array<CustomQuestionnaireStatus>}
   * @memberof UseCaseDetail
   */
  readonly customQuestionnaires: Array<CustomQuestionnaireStatus>;
}

/**
 * Check if a given object implements the UseCaseDetail interface.
 */
export function instanceOfUseCaseDetail(value: object): value is UseCaseDetail {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('businessOwner' in value) || value['businessOwner'] === undefined) return false;
  if (!('department' in value) || value['department'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('purpose' in value) || value['purpose'] === undefined) return false;
  if (!('euAiActRiskClass' in value) || value['euAiActRiskClass'] === undefined) return false;
  if (!('readiness' in value) || value['readiness'] === undefined) return false;
  if (!('questStatuses' in value) || value['questStatuses'] === undefined) return false;
  if (!('aiModels' in value) || value['aiModels'] === undefined) return false;
  if (!('customFieldValues' in value) || value['customFieldValues'] === undefined) return false;
  if (!('customQuestionnaires' in value) || value['customQuestionnaires'] === undefined) return false;
  return true;
}

export function UseCaseDetailFromJSON(json: any): UseCaseDetail {
  return UseCaseDetailFromJSONTyped(json, false);
}

export function UseCaseDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseDetail {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    businessOwner: json['business_owner'],
    department: (json['department'] as Array<any>).map(DepartmentFromJSON),
    description: json['description'],
    purpose: json['purpose'],
    euAiActRiskClass: EuAiActRiskClassEnumFromJSON(json['eu_ai_act_risk_class']),
    status: json['status'] == null ? undefined : UseCaseStatusEnumFromJSON(json['status']),
    updateUser: json['update_user'] == null ? undefined : json['update_user'],
    materiality: json['materiality'] == null ? undefined : MaterialityEnumFromJSON(json['materiality']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    readiness: json['readiness'],
    questStatuses: json['quest_statuses'],
    aiModels: (json['ai_models'] as Array<any>).map(AiModelWithAssessmentFromJSON),
    customFieldValues: (json['custom_field_values'] as Array<any>).map(CustomFieldValueReadFromJSON),
    customQuestionnaires: (json['custom_questionnaires'] as Array<any>).map(CustomQuestionnaireStatusFromJSON),
  };
}

export function UseCaseDetailToJSON(
  value?: Omit<
    UseCaseDetail,
    'id' | 'department' | 'readiness' | 'aiModels' | 'customFieldValues' | 'customQuestionnaires'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    business_owner: value['businessOwner'],
    description: value['description'],
    purpose: value['purpose'],
    eu_ai_act_risk_class: EuAiActRiskClassEnumToJSON(value['euAiActRiskClass']),
    status: UseCaseStatusEnumToJSON(value['status']),
    update_user: value['updateUser'],
    materiality: MaterialityEnumToJSON(value['materiality']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    quest_statuses: value['questStatuses'],
  };
}
